<div class="page-loader d-flex flex-column flex-row-fluid wrapper pt spacing-40">
  <app-logo-loader [title]="title" [message]="message"></app-logo-loader>
</div>
